// src/utils/sessionParams.ts
export type SessionParams = {
  cid?: string;
  groupId?: string | number;
  groupIdDefault?: string | number;
  mailaddress?: string;
};

export type MergeOptions = {
  /** true = KHÔNG ghi đè nếu URL đã có key (mặc định) */
  preferExisting?: boolean;
};

export const getSessionParams = (): SessionParams => {
  // Tuỳ bạn đang lưu ở đâu: sessionStorage/localStorage/context/API
  const raw: SessionParams = {
    cid: sessionStorage.getItem('cid') ?? undefined,
    groupId: sessionStorage.getItem('groupId') ?? undefined,
    mailaddress: sessionStorage.getItem('mailaddress') ?? undefined,
  };

  // Bỏ qua chuỗi "undefined"/"null"
  if (raw.mailaddress === 'undefined' || raw.mailaddress === 'null') raw.mailaddress = undefined;
  if (raw.cid === 'undefined' || raw.cid === 'null') raw.cid = undefined;
  return raw;
};

/**
 * Hợp nhất query string:
 * - Giữ lại params hiện có trên URL
 * - Thêm extra từ session; mặc định KHÔNG ghi đè nếu đã có
 *
 * @param pathOrSearch "/a?x=1" hoặc "?x=1"
 * @param extra        params thêm vào (thường từ session)
 * @param options      { preferExisting: true } -> chỉ bổ sung nếu chưa có
 */
export const mergeQueryString = (
  pathOrSearch: string,
  extra: SessionParams,
  options: MergeOptions = { preferExisting: true }
) => {
  const [pathname, qs = ''] = pathOrSearch.startsWith('?')
    ? ['', pathOrSearch.slice(1)]
    : pathOrSearch.split('?');

  const params = new URLSearchParams(qs);
  const { preferExisting = true } = options;

  Object.entries(extra).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    const val = String(v).trim();
    if (!val || val === 'undefined' || val === 'null') return;

    if (preferExisting) {
      if (!params.has(k)) params.set(k, val); // chỉ thêm khi CHƯA có
    } else {
      params.set(k, val); // ghi đè
    }
  });

  const search = params.toString();
  return pathname ? `${pathname}${search ? `?${search}` : ''}` : search ? `?${search}` : '';
};
